<!--TODO: For test purposes only should be removed later-->

<nz-range-picker
  [nzFormat]="'dd/MM/yyyy HH:mm:ss'"
  [(ngModel)]="dateRange"
  (ngModelChange)="onDateRangeChange($event)"
  nzShowTime
  [nzShowTime]="{ nzFormat: 'HH:mm:ss' }">
</nz-range-picker>

<app-date-range-picker
  [showTime]="true"
></app-date-range-picker>

<app-chip-input></app-chip-input>




